import { Instagram as IgIcon, Facebook as FbIcon, ArrowUpRight } from "lucide-react";
import { BRAND } from "../../lib/brand";

const tiles = [
  "https://images.pexels.com/photos/33287642/pexels-photo-33287642.jpeg",
  "https://images.pexels.com/photos/20306795/pexels-photo-20306795.jpeg",
  "https://images.pexels.com/photos/16109307/pexels-photo-16109307.jpeg",
  "https://images.pexels.com/photos/33834689/pexels-photo-33834689.jpeg",
  "https://images.unsplash.com/photo-1767786124293-289dafe6340d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1656010280162-772358d9f4ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzaWx2ZXIlMjByaW5nJTIwamV3ZWxyeXxlbnwwfHx8fDE3NzczMDc4NjV8MA&ixlib=rb-4.1.0&q=85",
];

export const InstagramSection = () => {
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="relative py-24 lg:py-32 bg-zinc-50 border-y border-zinc-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12">
          <div className="reveal">
            <p className="text-[11px] tracking-[0.4em] uppercase text-zinc-500 mb-5">
              06 — From The Studio
            </p>
            <h2 className="font-display font-light text-zinc-950 text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Follow us on
              <br />
              <span className="italic text-zinc-600">Instagram.</span>
            </h2>
            <p className="mt-5 text-zinc-600">
              New silver pieces, close-ups, and studio moments — shared almost
              every week.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="instagram-follow-btn"
              className="group inline-flex items-center justify-center sm:justify-start gap-2 sm:gap-3 h-12 sm:h-14 px-4 sm:px-6 bg-ig-gradient text-white text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.28em] uppercase hover:brightness-95 transition-all min-w-0"
            >
              <IgIcon className="h-4 w-4 shrink-0" />
              <span className="truncate">@{BRAND.instagramHandle}</span>
              <ArrowUpRight className="h-4 w-4 shrink-0 group-hover:rotate-45 transition-transform" />
            </a>
            <a
              href={BRAND.facebookUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="facebook-follow-btn"
              className="group inline-flex items-center justify-center sm:justify-start gap-2 sm:gap-3 h-12 sm:h-14 px-4 sm:px-6 bg-fb text-white text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.28em] uppercase hover:brightness-95 transition-all min-w-0"
            >
              <FbIcon className="h-4 w-4 shrink-0" />
              <span className="truncate">@{BRAND.facebookHandle}</span>
              <ArrowUpRight className="h-4 w-4 shrink-0 group-hover:rotate-45 transition-transform" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 lg:gap-3">
          {tiles.map((src, i) => (
            <a
              key={i}
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid={`instagram-tile-${i}`}
              className={`relative group aspect-square overflow-hidden bg-zinc-200 border border-zinc-200 img-zoom-wrap reveal reveal-delay-${
                (i % 5) + 1
              }`}
            >
              <img
                src={src}
                alt="Silver jewellery"
                className="absolute inset-0 h-full w-full object-cover img-zoom"
              />
              <div className="absolute inset-0 bg-zinc-950/0 group-hover:bg-zinc-950/50 transition-colors grid place-items-center">
                <IgIcon className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </a>
          ))}
        </div>

        <p className="mt-10 text-center text-[11px] tracking-[0.3em] uppercase text-zinc-500">
          DM on Instagram, Facebook or WhatsApp for the latest silver designs.
        </p>
      </div>
    </section>
  );
};
